/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import HeaderTable from '../BaseComponent/HeaderTable'
import Page from '../Pagination/Pagination'
import $ from 'jquery'
import {message} from 'antd'
import {Link} from 'react-router-dom'
import jMoment from 'moment-jalaali'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import cookie from 'react-cookies'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import SearchableCombo from '../BaseComponent/searchableCombo'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import TMS from '../BaseComponent/TMS'
import {MDBCol} from './CreateTask'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import FromToPicker from '../BaseComponent/FromToPicker'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import Loader from '../loaders/loader'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'
import Pageing from '../Pagination/pageing'
import {productShop} from '../../lib/path'
import AutoComplete from '../BaseComponent/autocomplete'

class ReportHistory extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      buttonClicked: false,
      printInfo: [],
      lengthProviders: 0,
      planDateMin: '',
      planDateMax: '',
      list: [],
      providers: [],
      products: [],
      providerId: '',
      productId: '',
      tasks: [],
      sections: [],
      modalReject: false,
      modalAccept: false,
      fromDate: '',
      toDate: '',
      operators: [],
      personId: '',
      department: [],
      pageNumber: 1,
      pageSize: 10,
      countAll: 0,
      sortBy: 'activityDate_desc',
      getSort: '',
      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تاریخ آخرین تغییر',
          value: 'time',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'کاربر',
          value: 'user',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'دپارتمان',
          value: 'departmentTitle',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'بخش',
          value: 'sectionTitle',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'فعالیت',
          value: 'taskTitle',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تامین کننده',
          value: 'providerTitle',
          sorted: false,
          direction: null,
          sortable: false
        },

        {
          name: 'کالا',
          value: 'productTitle',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'بازه زمانی',
          value: 'taskTimeMinuteMin',
          sorted: false,
          direction: null,
          sortable: true
        },

        {
          name: 'وضعیت',
          value: 'state',
          sorted: false,
          direction: null,
          sortable: true
        },

        {
          name: 'تعداد',
          value: 'count',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'تاریخ فعالیت',
          value: 'activityDate',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'زمان تخمینی',
          value: 'timeMinuteUser',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'زمان مورد تایید',
          value: 'timeMinuteOperator',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'توضیحات',
          value: 'description',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'بازخورد',
          value: 'seen',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'حذف',
          value: 'seen',
          sorted: false,
          direction: null,
          sortable: false
        }
      ]
    }
  }

  changeOrg(e) {
    let value = e.target.value
    if (value === '') {
      this.setState({
        sections: []
      })
    } else {
      let personId = localStorage.getItem('personId')

      http
        .get(`${TMS.TMS_MANAGE_BASE_SECTION_LIST}?departmentId=${value}&personId=${personId}`, {})
        .then((response) => {
          if (response.data.error === null) {
            this.setState({
              sections: response.data.object
            })
          } else {
            this.setState({
              sections: []
            })
          }
        })
    }
  }

  getValueProvider = (providerId) => {
    if (providerId === null) {
      this.setState({
        products: [],
        providerId: null
      })
    } else {
      this.setState({
        providerId
      })
      let id = providerId

      http
        .get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PRODUCT}`, {
          params: {
            sortByTitle: true,
            providerId: id
          }
        })
        .then((response) => {
          if (response.data.error === null) {
            var products = response.data.object
            for (let i = 0; i < products.length; i++) {
              products[i]['value'] = products[i].productId
              products[i]['label'] = products[i].articleId + ' - ' + products[i].productName
            }
            this.setState({
              products: response.data.object
            })
          } else {
            this.setState({
              products: []
            })
          }
        })
    }
  }

  getValueProduct = (productId) => {
    if (productId === null) {
      this.setState({
        productId: ''
      })
    } else {
      this.setState({
        productId
      })
    }
  }

  getValueOperator = (personId) => {
    if (personId === null) {
      this.setState({
        personId: ''
      })
    } else {
      this.setState({
        personId
      })
    }
  }

  changeSec(e) {
    let value = e.target.value
    if (value === '') {
      this.setState({
        tasks: []
      })
    } else {
      http.get(`${TMS.TMS_MANAGE_BASE_TASK_LIST}?sectionId=${value}`, {}).then((response) => {
        if (response.data.error === null) {
          this.setState({
            tasks: response.data.object
          })
        } else {
          this.setState({
            tasks: []
          })
        }
      })
    }
  }

  componentDidMount() {
    let personId = localStorage.getItem('personId')

    http.get(`${TMS.TMS_MANAGE_BASE_ORGANIZATION_LIST}?personId=${personId}`, {}).then((response) => {
      if (response.data.error === null) {
        this.setState({
          department: response.data.object
        })
      }
    })

    if (this.props.match.params.activityId != undefined) {
      this.fetchHistory(this.props.match.params.activityId || '')
    }

    http.get(`${USER_MANAGE.USER_MANAGE_LIST_OPERATOR}`, {}).then((response) => {
      if (response.data.error === null) {
        var operators = response.data.object
        for (let i = 0; i < operators.length; i++) {
          operators[i]['value'] = operators[i].personId
          operators[i]['label'] = operators[i].personId + ' - ' + operators[i].name
        }
        this.setState({
          operators: response.data.object
        })
      }
    })

    // http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`,{
    //     params: {
    //         sortByTitle: true,
    //         all: true

    //     }
    // }).then((response)=>{
    //     if(response.data.error==null){

    //         var provider = response.data.object;
    //         for (let i = 0; i < provider.length; i++) {
    //             provider[i]['value'] = provider[i].providerId;
    //             provider[i]['label'] =provider[i].providerId +' - '+ provider[i].title;
    //         }

    //         this.setState({
    //             providers:response.data.object
    //         })
    //     }
    //     else{
    //         this.setState({
    //             providers:[]
    //         })
    //     }
    // })

    sessionStorage.removeItem('params')

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.basketFilterComponent').slideUp()
      })
    })
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
  }

  fetchHistory(activityId) {
    sessionStorage.setItem('params', `activityId=${activityId}`)
    http
      .get(
        TMS.TMS_MANAGE_ACTIVITY_HISTORY +
          '?export=false' +
          '&pageSize=10' +
          '&pageNumber=1' +
          `&activityId=${activityId}`
      )
      .then((response) => {
        if (response.data.error == null) {
          $('.showBaseTable,.print').fadeIn()
          this.setState({
            list: response.data.object.result,
            countAll: response.data.object.countAll
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
          // message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          this.setState({
            items: []
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (this.props.match.params.activityId !== nextProps.match.params.activityId) {
      this.fetchHistory(nextProps.match.params.activityId || '')
      return false
    }
  }

  //

  getReport = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    this.setState({
      loading: true
    })
    http
      .get(`${TMS.TMS_MANAGE_ACTIVITY_HISTORY}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          $('.showBaseTable,.print').fadeIn()

          if (!exportStatus) {
            this.setState({
              list: response.data.object.result,
              countAll: response.data.object.countAll,
              loading: false,
              buttonClicked: true
            })
          } else if (exportStatus) {
            this.setState({
              printInfo: response.data.object.result,
              countAll: response.data.object.countAll,
              loading: false
            })
          }
        } else {
          $('.showBaseTable,.print').fadeOut()

          this.setState({
            list: [],
            countAll: 0,
            loading: false
          })
          message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
        this.setState({
          loading: false
        })
      })
  }

  createFilter = (exportStatus) => {
    let filter = {}
    let sectionId = document.getElementById('sectionId').value
    let taskId = document.getElementById('taskId').value
    let departmentId = document.getElementById('departmentId').value
    let description = document.getElementById('description').value.trim()

    let state = document.getElementById('state').value
    let activityDeleted = document.getElementById('activityDeleted').value
    let activityDateMin = this.state.fromDate
    let activityDateMax = this.state.toDate
    let personId = this.state.personId !== '' ? this.state.personId.personId : ''
    let providerId = this.state.providerId
    let productId = this.state.productId === '' || this.state.productId === null ? '' : this.state.productId.productId
    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }
    if (sectionId !== '') {
      filter.sectionId = sectionId
    }
    if (taskId !== '') {
      filter.taskId = taskId
    }
    if (departmentId !== '') {
      filter.departmentId = departmentId
    }
    if (state !== '' && state.length) {
      filter.state = state
    }
    if (activityDeleted !== '') {
      filter.activityDeleted = activityDeleted
    }
    if (activityDateMin !== '') {
      filter.activityDateMin = activityDateMin
    }
    if (activityDateMax !== '') {
      filter.activityDateMax = activityDateMax
    }
    if (personId !== '') {
      filter.personId = personId
    }
    if (providerId !== '') {
      filter.providerId = providerId
    }
    if (productId !== '') {
      filter.productId = productId
    }
    if (description !== '') {
      filter.description = description
    }
    return filter
  }

  filter() {
    let activityDeleted = document.getElementById('activityDeleted').value.trim()
    let activityDateMin = this.state.fromDate
    let activityDateMax = this.state.toDate

    if (
      activityDeleted === '' &&
      departmentId === '' &&
      personId === '' &&
      activityDateMin === '' &&
      activityDateMax === '' &&
      state === '' &&
      sectionId === '' &&
      taskId === '' &&
      providerId === '' &&
      productId === ''
    ) {
      message.error('حداقل یک فیلتر وارد شود')
    } else if ((activityDateMin !== '' || activityDateMin === null) && isNaN(activityDateMin)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((activityDateMax !== '' || activityDateMax === null) && isNaN(activityDateMax)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else {
      // this.setState({
      //     toPrintDate:this.state.fromDate === ''? '-' :jMoment(this.state.fromDate).format('jYY/jMM/jDD')
      //     ,
      //     fromPrintDate:this.state.toDate === ''? '-' :jMoment(this.state.toDate).format('jYY/jMM/jDD')
      //
      // })
      this.setState(
        {
          pageNumber: 1
        },
        () => {
          this.getReport(false)
        }
      )
    }
  }

  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getReport(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getReport(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getReport(false)
    }
  }

  exportExcel = () => {
    let filter = this.createFilter(true)

    http
      .get(`${TMS.TMS_MANAGE_ACTIVITY_HISTORY}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result,
            countAll: response.data.object.countAll
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i].timeMinuteOperator = this.convertCount(excelReport[i].timeMinuteOperator)
            excelReport[i].timeMinuteUser = this.convertCount(excelReport[i].timeMinuteUser)
            excelReport[i].count = this.convertCount(excelReport[i].count)
            excelReport[i]['time'] = jMoment(excelReport[i]['time']).format('jYY/jMM/jDD HH:mm')
            excelReport[i]['creationTime'] = jMoment(excelReport[i]['creationTime']).format('jYY/jMM/jDD HH:mm')
            excelReport[i]['activityDate'] = jMoment(excelReport[i]['activityDate']).format('jYY/jMM/jDD HH:mm')
            excelReport[i]['state'] = this.convertState(excelReport[i]['state'])
            if (excelReport[i]['activityDeleted']) {
              excelReport[i]['activityDeleted'] = 'حذف شده'
            } else {
              excelReport[i]['activityDeleted'] = 'حذف نشده'
            }
          }
          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {})
  }

  getPrintInfo = () => {
    this.getReport(true)
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  onResultFetched(data) {
    this.setState({
      list: data
    })
  }

  changeDropDown(data) {
    this.setState({
      list: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  convertState = (state) => {
    switch (state) {
      case 100:
        return 'در انتظار'
        break
      case 10:
        return <img src={require('../../image/confirm.svg')} style={{width: '20px'}} />
        break
      case 20:
        return <img src={require('../../image/ignor.svg')} style={{width: '20px'}} />
        break
      default:
        return '-'
    }
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }
  convertCount = (count) => {
    if (count !== null) {
      return count.toFixed(1).replace('.0', '')
    } else {
      return ''
    }
  }

  render() {
    let {pageNumber, pageSize, loading} = this.state
    let name = cookie.load('name')
    let columns = [
      'ردیف',
      'تاریخ آخرین تغییر',
      'دپارتمان',
      'بخش',
      'فعالیت',
      'تامین کننده',
      'کالا',
      'وضعیت',
      'تاریخ ثبت',
      'تعداد',
      'تاریخ فعالیت',
      'زمان تخمینی',
      'توضیحات',
      'بازخورد',
      'حذف نشده'
    ]

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />

        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش تاریخچه فعالیت ها"
              headerColSpan={13}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={5}
              rightColSpan={6}
              centerColSpan={2}
              centerSection={''}
              rightSection={''}
              columns={columns}
            />
            <tbody>
              {this.state.printInfo.map((item, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{jMoment(item.time).format('jYYYY/jMM/jDD HH:mm')}</td>
                  <td>{item.departmentTitle}</td>
                  <td>{item.sectionTitle}</td>
                  <td>{item.taskTitle}</td>
                  <td>{item.providerTitle}</td>
                  <td>{item.productTitle}</td>
                  <td>{this.convertState(item.state)}</td>
                  <td>{jMoment(item.creationTime).format('jYYYY/jMM/jDD')}</td>
                  <td>{this.convertCount(item.count)}</td>
                  <td>{jMoment(item.activityDate).format('jYYYY/jMM/jDD')}</td>
                  <td>{this.convertCount(item.timeMinuteUser) + ' دقیقه '}</td>
                  <td>{item.description}</td>
                  <td>{item.comment}</td>
                  <td>{item.activityDeleted ? ' شده' : 'نشده'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش تاریخچه فعالیت ها.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'time'}
                field={'time'}
                title={'تاریخ آخرین تغییر'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'name'}
                field={'user.name'}
                title={'کاربر'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'departmentTitle'}
                field={'departmentTitle'}
                title={'دپارتمان'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'sectionTitle'}
                field={'sectionTitle'}
                title={'بخش'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'taskTitle'}
                field={'taskTitle'}
                title={'فعالیت'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'providerTitle'}
                field={'providerTitle'}
                title={'تامین کننده'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'productTitle'}
                field={'productTitle'}
                title={'کالا'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'taskTimeMinuteMin'}
                field={'taskTimeMinuteMin'}
                title={'بازه زمانی از'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'taskTimeMinuteMax'}
                field={'taskTimeMinuteMax'}
                title={'بازه زمانی تا'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'state'}
                field={'state'}
                title={'وضعیت'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'count'}
                field={'count'}
                title={'تعداد'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'activityDate'}
                field={'activityDate'}
                title={'تاریخ فعالیت'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'timeMinuteUser'}
                field={'timeMinuteUser'}
                title={'زمان تخمینی'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'description'}
                field={'description'}
                title={'توضیحات'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'comment'}
                field={'comment'}
                title={'بازخورد'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'activityDeleted'}
                field={'activityDeleted'}
                title={'وضعیت حذف'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>مدیریت فعالیت ها</li>
            <li>تاریخچه فعالیت ها</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={'/tms/manageTask/history'} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel=" تاریخ فعالیت از"
                  toLabel=" تاریخ فعالیت تا"
                  defaulValue={false}
                  fromId="from"
                  toId="to"
                />

                <div className="formComponent">
                  <label className="font-weight-bold" htmlFor="ماهیت">
                    دپارتمان
                  </label>
                  <select
                    className="custom-select"
                    onChange={this.changeOrg.bind(this)}
                    name="departmentId"
                    id="departmentId"
                  >
                    <option value="">------</option>
                    {this.state.department.map((item, index) => (
                      <option value={item.id} key={index}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="formComponent">
                  <label className="font-weight-bold" htmlFor="ماهیت">
                    بخش
                  </label>
                  <select
                    className="custom-select"
                    onChange={this.changeSec.bind(this)}
                    name="sectionId"
                    id="sectionId"
                  >
                    <option value="">------</option>
                    {this.state.sections.map((item, index) => (
                      <option value={item.id} key={index}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="formComponent">
                  <label className="font-weight-bold" htmlFor="ماهیت">
                    فعالیت
                  </label>
                  <select className="custom-select" name="taskId" id="taskId">
                    <option value="">------</option>
                    {this.state.tasks.map((item, index) => (
                      <option value={item.id} key={index}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="formComponent selectComponent">
                  <AutoComplete
                    label="تامین کننده"
                    api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                    textField="title"
                    valueField="providerId"
                    id="provider"
                    value={this.state.providerId}
                    setValue={this.getValueProvider}
                  />
                  {/* <SearchableCombo
                                        options={this.state.providers}
                                        getValueCombo={this.getValueProvider}
                                        lableText='تامین کننده'
                                        placeholder='------'
                                        isClearable={true}
                                        isMulti={false}
                                        className='font-weight-bold'

                                    /> */}
                </div>
                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.products}
                    getValueCombo={this.getValueProduct}
                    lableText="کالا"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    className="font-weight-bold"
                  />
                </div>

                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.operators}
                    getValueCombo={this.getValueOperator}
                    lableText="کاربران"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    className="font-weight-bold"
                  />
                </div>

                <div className="formComponent">
                  <label className="font-weight-bold" htmlFor="ماهیت">
                    وضعیت
                  </label>
                  <select className="custom-select" name="state" id="state">
                    <option value="">------</option>
                    <option value={100}>در انتظار</option>
                    <option value={10}>تایید شده</option>
                    <option value={20}>تایید نشده</option>
                  </select>
                </div>
                <div className="formComponent">
                  <label className="font-weight-bold">وضعیت حذف</label>
                  <select className="custom-select" name="activityDeleted" id="activityDeleted">
                    <option value="">------</option>
                    <option value={1}>حذف شده</option>
                    <option value={0} selected>
                      حذف نشده
                    </option>
                  </select>
                </div>

                <div className="formComponent">
                  <label className="font-weight-bold" htmlFor="ماهیت">
                    توضیحات
                  </label>
                  <textarea id="description" className="form-control" />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <Sort data={this.state.sortData} getSort={this.getSort} />
                <tbody>
                  {this.state.list.map((item, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                      <td>{jMoment(item.time).format('jYYYY/jMM/jDD HH:mm')}</td>
                      <td>{item.user !== null && item.user.name}</td>
                      <td>{item.departmentTitle}</td>
                      <td>{item.sectionTitle}</td>
                      <td>{item.taskTitle}</td>
                      <td>{item.providerTitle}</td>
                      <td>
                        <a target="_blank" href={productShop({articleId: item.articleId})}>
                          {item.productTitle}
                        </a>
                      </td>
                      <td>{item.taskTimeMinuteMin + ' - ' + item.taskTimeMinuteMax + ' دقیقه '}</td>
                      <td>{this.convertState(item.state)}</td>
                      <td>{this.convertCount(item.count)}</td>
                      <td>{jMoment(item.activityDate).format('jYYYY/jMM/jDD')}</td>
                      <td>{this.convertCount(item.timeMinuteUser) + ' دقیقه '}</td>
                      <td>{item.state === 10 && item.timeMinuteOperator + ' دقیقه '}</td>
                      <td style={{width: '200px'}}>{item.description}</td>
                      <td style={{width: '200px'}}>{item.comment}</td>
                      <td>
                        {item.activityDeleted ? (
                          <img title="حذف شده" src={require('../../image/confirm.svg')} />
                        ) : (
                          <img title="حذف نشده" src={require('../../image/ignor.svg')} />
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.countAll}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ReportHistory
